class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', evt => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', event => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', event => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();

        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      if (document.body.classList.contains('cart-page-template')) {
        window.location.href = '/cart';
      } else {
        this.classList.add('animate', 'active');
      }
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    document.querySelector('html').classList.add('overflow-y-hidden');
    setTimeout(function() {
      const cartDrawerShippingdigit = parseFloat(
        document
          .querySelector('.cart-drawer__shipping-msg')
          .getAttribute('freedigit')
          .match(/\d+(?:\d{3})*(?:\.\d+)?/g)
          .join('')
      );
      const cartDrawerShippingMsg = document.querySelector('.cart-drawer__shipping-msg').getAttribute('limit-reach');
      const cartDrawerShippingMsgDigit = document.querySelector('.cart-drawer__shipping-msg [data-left-to-spend]');

      let totalsTotalValue = document
        .querySelector('.totals .totals__total-value')
        .innerText.match(/\d+(?:,\d{3})*(?:\.\d+)?/g)[0];
      totalsTotalValue = totalsTotalValue.replace(/,/g, '');
      const currencydigit = document
        .querySelector('.totals .totals__total-value')
        .innerText.replaceAll(',', '')
        .split(totalsTotalValue)[0];
      const progressBar = document.querySelector('.cart-drawer__progress .progress-done');

      function updateProgressBar() {
        let progressPercentage = (totalsTotalValue / cartDrawerShippingdigit) * 100;
        if (progressPercentage > 100) {
          progressPercentage = 100;
        }
        if (progressPercentage >= 100) {
          document.querySelector('.cart-drawer__shipping-msg').innerText = cartDrawerShippingMsg;
        } else {
          const remainingAmount = cartDrawerShippingdigit - totalsTotalValue;
          cartDrawerShippingMsgDigit.innerText = currencydigit + Number(remainingAmount).toFixed(2);
        }
        progressBar.style.width = Math.floor(progressPercentage) + '%';
      }
      updateProgressBar();
    }, 300);
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.querySelector('html').classList.remove('overflow-y-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', event => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach(section => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
